export default __webpack_public_path__ + "static/media/swissmarketsReal02_downloadMT4.8ec6f0e2.png";